export const isSixDigitCode = (value: string) => /^\d{6}$/.test(value);
